/*!
 * Copyright © 2005-2025 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Alfresco Example Content Application
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail. Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * from Hyland Software. If not, see <http://www.gnu.org/licenses/>.
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { WorkflowSettingsService } from './workflow-settings.service';

/**
 * Closes the workflow routes when the administrator has the feature off.
 *
 * Hiding the menu entries alone would leave `/my-tasks` and `/workflow`
 * reachable to anyone who kept the url — the flag has to hold at the door,
 * not just on the sign. The flag may not have been read yet on a cold load
 * (guards run before the shell header does), so this waits for the one read
 * the service performs per session.
 */
export const workflowEnabledGuard: CanActivateFn = () => {
  const settings = inject(WorkflowSettingsService);
  const router = inject(Router);

  settings.load();
  return settings.whenLoaded.pipe(map(() => (settings.enabled() ? true : router.parseUrl('/all-documents'))));
};
